"use client";
import { useSuspenseQuery } from "@apollo/client/react";
import { notFound } from "next/navigation";

import { BackButton, ButtonBar, ButtonGroup, IfUserIs, Main, ThemedHeading, ThemedPage, Thread } from "@/components";
import CompetitionCountdown from "@/components/competition-countdown";
import { THREAD } from "@/gql/queries/thread";

import ThreadAdminControls from "./admin-controls";

export default function PageThread({ threadId }: { threadId: number }) {
  const { data } = useSuspenseQuery(THREAD, { variables: { id: threadId } })

  if (!data.thread) {
    notFound();
  }

  const threadUser = data.thread.posts[0]?.user;

  if (!threadUser) notFound();

  return (
    <ThemedPage theme={threadUser.theme}>
      <Main theme={threadUser.theme}>
        <ThemedHeading theme={threadUser.theme}>
          {data.thread.type === "COMPETITION"
            ? "Competition"
            : "Community Thread"}
        </ThemedHeading>

        <ButtonBar>
          <ButtonGroup>
            <BackButton />
          </ButtonGroup>
          <ButtonGroup align="right">
            <IfUserIs admin>
              <ThreadAdminControls
                threadId={data.thread.id}
                threadType={data.thread.type}
              />
            </IfUserIs>
          </ButtonGroup>
        </ButtonBar>
        {data.thread.type === "COMPETITION" && (
          <div className="text-center text-2xl font-bold">
            <CompetitionCountdown endDate={data.thread.endDate} />
          </div>
        )}
        <Thread thread={data.thread} />
      </Main>
    </ThemedPage>
  );
}